import React, { Component } from 'react';
import { UnmountClosed } from 'react-collapse';
import moment from 'moment-timezone';

import Icon from './../Icon';
import UploadButton from './../UploadButton';
import FinalPaperFileRow from './FinalPaperFileRow';
import ModalFilesProgress from './ModalFilesProgress';

import { STATUS_PROGRESS } from './../../store/orders/actions';

class UploadReportFile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }

        this.toggle = this.toggle.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    toggle() {
        this.setState(state => Object.assign({}, state, {
            isOpen: !state.isOpen
        }));
    }

    onChange(event) {
        const { uploadFile } = this.props;
        const fileList = event.target.files;
        for (let i = 0; i < fileList.length; i++) {
            uploadFile(fileList[i], 'file_pregrader_comment');
        }
        event.target.value = '';
    }

    render() {
        const { fileList, onResize, status, removeFile, uploadFile, error } = this.props;
        const { isOpen } = this.state;
        console.log(error);
        if (!fileList.length) {
            if (status !== STATUS_PROGRESS) {
                return null;
            }
        }
        const sortedList = fileList.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)));
        const filesStr = `${sortedList.length} ${sortedList.length === 1 ? 'file' : 'files'}`;
        const btnText = !fileList.length ? 'Upload files' : 'Upload more';

        return (
            <div className="order-tab-collapse">
                <div className="order-tab-collapse-head" onClick={this.toggle}>
                    <Icon className="svg-icon" iconName="clip" />
                    <span className="order-tab-head-name">Report files ({filesStr})</span>
                    {isOpen
                        ? <span className="arrow-down active"></span>
                        : <span className="arrow-down"></span>
                    }

                    <ModalFilesProgress fileList={fileList} uploadFile={uploadFile} fileInputRef={this.fileInputRef} removeFile={removeFile} />

                </div>
                <UnmountClosed isOpened={isOpen} className="order-tab-collapse-body" onRender={onResize}>
                    <div className="order-tab-content">
                        {status === STATUS_PROGRESS &&
                            <div className="row space-between vertical mb15">
                                <div>
                                    {filesStr} uploaded
                                </div>
                                <div>
                                    <UploadButton className="btn btn-bright" multiple onChange={this.onChange} inputRef={ref => this.fileInputRef = ref}>{btnText}</UploadButton>
                                </div>
                            </div>
                        }
                        <div>
                            {sortedList.map(file =>
                                <FinalPaperFileRow file={file} key={file._id} onRemove={status === STATUS_PROGRESS && removeFile} />
                            )}
                        </div>
                    </div>
                </UnmountClosed>
            </div>
        );
    }
}
export default UploadReportFile;


// WEBPACK FOOTER //
// ./src/components/order/UploadReportFile.js